export const SEARCH_ORDER = 'name';
export const SEARCH_MAX_RESULTS = 15;
